module.exports = __webpack_public_path__ + "img/cancel.4b636ea5.svg";